module.exports = __webpack_public_path__ + "static-portal/img/33-1.191db40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/33-1.jpg
// module id = yB16
// module chunks = 4